import App from '@/models/App'

export default class OrderingRecieverEstimateStatusLog extends App {
    static get entity() {
        return 'OrderingReceiverEstimateStatusLogs'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingEstimateId: this.attr(''),
            orderingAccountId: this.attr(''),
            status: this.attr(0),
            prevStatus: this.attr(false),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {},
    }
}
